import { service } from "@ember/service";
import type Features from "ember-feature-flags";
import type { Issuer } from "./open-id-connect";
import OpenIdConnectService from "./open-id-connect";

export default class AphpConnectMedic extends OpenIdConnectService {
  @service declare features: Features;

  featureFlag = "enabling_auth_by_aphp_medic";
  imageUrl = "/assets/ui-images/aphp.png";
  issuer: Issuer = "aphp-medic";
  label = "APHP Connect";
  override route = "login.aphp-medics";
}
